{
  "destinationSearch": {
    "calendarButton": "#Hintakalenteri#"
  },
  "serviceForms": {
    "refundsCompensations": {
      "continue": "Continue",
      "newCase": "Create new case",
      "viewCase": "View existing cases",
      "infoAccordion": [
        {
          "title": "Eligible refund and compensation cases",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Documents needed for submitting a claim",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Gift voucher benefits",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        }
      ]
    },
    "specialAssistanceWizard": {
      "infoAccordion": [
        {
          "title": "Accordion title 1",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Accordion title 2",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Accordion title 3",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        }
      ]
    }
  },
  "ticketSelection": {
    "travelClassAlternative": "Valitsemassasi matkustusluokassa ei löytynyt lentoja, joten tässä muita vaihtoehtoja."
  },
  "loginPromotion": {
    "loginHeading": {
      "inMmb": "Kirjaudu sisään ja kerää kaikki pisteesi"
    },
    "benefitText": "Kirjaudu sisään sähköpostillasi tai Finnair Plus-numerollasi."
  },
  "indiaRedirectNotification": "Hi! We redirected you to our international site from the Indian country site, which is temporarily closed for enhancements. You can book flights and use our services on this site as you would on the Indian one. We are sorry for any inconvenience.",
  "chatUserForm": {
    "intro": "Täytäthän nämä tiedot, jotta voimme palvella sinua paremmin.",
    "firstName": {
      "label": "Etunimi",
      "pattern": "Etunimi on pakollinen (erikoismerkit eivät ole sallittuja).",
      "maxlength": "Etunimi on liian pitkä (enintään 30 merkkiä).",
      "required": "Etunimi on pakollinen."
    },
    "lastName": {
      "label": "Sukunimi",
      "pattern": "Sukunimi on pakollinen (erikoismerkit eivät ole sallittuja).",
      "maxlength": "Sukunimi on liian pitkä (enintään 30 merkkiä).",
      "required": "Sukunimi on pakollinen."
    },
    "emailAddress": {
      "label": "Sähköpostiosoite",
      "pattern": "Tarkista, että sähköpostiosoite on kirjoitettu oikein.",
      "required": "Sähköposti on pakollinen."
    },
    "bookingRefQ": {
      "noBookingReference": "Ei",
      "yesBookingReference": "Kyllä",
      "label": "Liittyykö kysymyksesi lentovaraukseen?",
      "required": "\"Liittyykö kysymyksesi lentovaraukseen?\" on pakollinen."
    },
    "bookingReference": {
      "label": "Varausnumerosi",
      "placeholder": "Esim. Y2KP3D",
      "maxlength": "Enimmäispituus on 6 merkkiä.",
      "pattern": "Varaustunnuksessa tulee olla 6 merkkiä, esim. Y2KP3D. Siinä ei voi olla numeroita 1 tai 0 eikä erikoismerkkejä.",
      "required": "Varaustunnus on pakollinen."
    },
    "submitText": "Aloita keskustelu"
  },
  "blueWingsSEO": {
    "bluewingTitle": "Blue Wings -tarinat",
    "articlePlural": "{{count}} artikkelia",
    "articleSingular": "{{count}} artikkeli",
    "tags": {
      "activeHolidays": "Aktiivilomat",
      "airportAndFlights": "Lentokenttä ja lennot",
      "autumn": "Syksy",
      "baggage": "Matkatavarat",
      "beachHolidays": "Rantalomat",
      "booking&Payments": "Varaukset ja maksaminen",
      "businessTravel": "Liikematkustus",
      "check-inAndBoarding": "Lähtöselvitys ja koneeseennousu",
      "cityBreaks": "Kaupunkilomat",
      "cross-countryJourneys": "Matkustus maata pitkin",
      "culinaryTrips": "Ruokamatkat",
      "cultureAndEvents": "Kulttuurimatkat",
      "customerService": "Asiakaspalvelu",
      "destinations": "Kohteet",
      "digitalServices": "Digipalvelut",
      "entertainment&InternetAccess": "Viihde ja internetyhteys",
      "familyTravel": "Perhematkat",
      "finnairEmployees": "Finnairilaiset",
      "finnairLounges": "Finnair Lounget",
      "finnairPlus": "Finnair Plus",
      "finnairStories": "Finnair-tarinat",
      "fleet": "Laivasto",
      "groupTravel": "Group travel",
      "health&MedicalIssues": "Terveys ja erityistarpeet",
      "hiddenGems": "Piilotetut helmet",
      "investorRelationsBlog": "Sijoittajasuhdeblogi",
      "lifestyle": "Lifestyle",
      "nordicKitchen": "Nordic Kitchen",
      "off-seasonTravel": "Sesongin ulkopuolella matkustus",
      "outdoorAdventures": "Luontomatkat",
      "pets": "Lemmikit",
      "santa'sOfficialAirline": "Joulupukin virallinen lentoyhtiö",
      "santasOfficialAirline": "Joulupukin virallinen lentoyhtiö",
      "seasonalDestination": "Kausikohde",
      "seasonality": "Seasonality",
      "seats&TravelClasses": "Istuinpaikat ja matkustusluokat",
      "smoothTravel": "Sujuva matkustaminen",
      "soloTravel": "Yksin matkustaminen",
      "spring": "Kevät",
      "summer": "Kesä",
      "sustainability": "Vastuullisuus",
      "travelExperience": "Matkalla",
      "travelPreparations": "Matkavalmistelut",
      "travelTips": "Matkavinkit",
      "winter": "Talvi",
      "worldOfFinnair": "Finnairin maailma",
      "yourFinnairGuide": "Finnairilaisen matkassa"
    }
  }
}
